import { Model } from "@/models";
export default class ContactForm extends Model {
  static type = "contactForms";
  metadata: any;
}
